export default "__VITE_ASSET__1bdae636__"